module.exports = __webpack_public_path__ + "static/media/quality-control-banner.fbde28f0.png";